<div
    tuiResizeable
    class="t-resizable"
    [class.t-resizable-auto-height]="autoHeight"
>
    <ng-content></ng-content>

    <div
        class="t-handle t-handle-left-side"
        [tuiResizer]="[-1, 0]"
        (tuiSizeChange)="sizeChange.emit($event)"
    ></div>

    <div
        *ngIf="!autoHeight"
        class="t-handle t-handle-bottom-side"
        [tuiResizer]="[0, 1]"
        (tuiSizeChange)="sizeChange.emit($event)"
    ></div>

    <div
        class="t-handle t-handle-right-side"
        [tuiResizer]="[1, 0]"
        (tuiSizeChange)="sizeChange.emit($event)"
    ></div>
</div>
